import React from 'react'
import { useTranslation } from 'react-i18next';
import Helper from '../../../../helper/Helper';
import { PAYMENT_MODE } from '../../../../data/constant';

export default function InvoiceAddress(props) {
     const { customer, company, order, title } = props;
     const { t } = useTranslation();
     const fontSize = { fontSize: "13px", color: "#3a3030", fontWeight: "500" }
     return (
          <div className="row mt-2">
               <div className="col-8">
                    <div className='row'>
                         <div className='col-6'>
                              {company &&
                                   <address style={fontSize}>
                                        <b className='text-primary'>{company.company_name}</b><br />
                                        {company.address}  {company.city} {customer.state_name} {customer.pincode} IN<br />
                                        {t('gst')} : {company.gst_number} <br />
                                        {t('email')} : {company.email} <br /> {t('mobile')} {company.phone_number} <br />
                                        {t('contact_person')} : {company.contact_person}
                                   </address>
                              }
                         </div>
                         <div className='col-6'>
                              <br />
                              {customer &&
                                   <address style={fontSize}>
                                        <b className='text-primary'> {t(title)}</b><br />
                                        <b className='text-primary'>{customer.bussiness_name}</b><br />
                                        {customer.full_name} {customer.mobile} <br />
                                        {customer.address} {customer.city} {customer.state_name} {customer.pincode} IN<br />
                                        {t('gst')} : {customer.gst_number} <br />
                                        {t('email')} : {customer.email} <br />
                                        {t('pan')} : {customer.pan_number} <br />
                                   </address>
                              }
                         </div>
                    </div>
               </div>
               <div className="col-4">
                    <div className="row pt-2 bg-primary text-white">
                         <div className="col-12">
                              <p>
                                   {title === 'payment_receipt' ? (
                                        <b>{t('received_amount')} : {Helper.formatNumber(order.amount)}</b>
                                   ) : (
                                        <b>{t('net_amount')} : {Helper.formatNumber(order.net_amount)}</b>
                                   )
                                   }
                              </p>
                         </div>
                    </div>
                    {customer &&
                         <div className="pt-2">
                              <span style={fontSize}>
                                   {title === 'bill_to' || title === 'quote_to' || title === 'credit_note' ? (
                                        <>
                                             {t('invoice_date')} : {Helper.formatDate(order.invoice_date)}
                                        </>
                                   ) : (
                                        title === 'payment_receipt' ? (
                                             <>
                                                  {t('payment_date')} : {Helper.formatDate(order.payment_date)}
                                             </>
                                        ) : <>
                                             {t('issue_date')} : {Helper.formatDate(order.po_date)}
                                        </>
                                   )}
                              </span>
                              <br />
                              <span style={fontSize}>
                                   {title === 'bill_to' ? (
                                        <>{t('due_date')} : {order.due_date == null ? '' : Helper.formatDate(order.due_date)}</>
                                   ) : (
                                        title === 'payment_receipt' ? (
                                             <>
                                                  {t('reference')} : {order.reference}
                                             </>
                                        ) : (
                                             title === 'credit_note' ? (
                                                  <></>
                                             ) : 
                                             <>
                                                  {t('valid_until')} : {order.valid_until == null ? '' : Helper.formatDate(order.valid_until)}
                                             </>
                                        )

                                   )
                                   }
                              </span>
                              <br />
                              <span style={fontSize}>
                                   {title === 'payment_receipt' ?
                                        (<>{t('payment_mode')} : {PAYMENT_MODE[order.mode]}</>) :
                                        (<>{t('play_of_supply')} : {customer.state_name}</>)
                                   }
                              </span>
                         </div>
                    }
               </div>
          </div>
     )
}
